const scriptLoader = ({ scriptSrc }) => {
  const tagScriptElement = document.createElement("script");
  tagScriptElement.src = scriptSrc;
  document.head.appendChild(tagScriptElement);
};

export default scriptLoader;
